import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { FaqDto } from '../../../../core/dto/faq/faqdto';
import { FAQViewImpl } from './faqview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { FAQCSSStyleImpl } from './faqcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { FAQAPIModelImpl, FAQAPIModel } from './faqapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface FAQComponentProps extends CRBTUIComponentProps
{

}

export interface FAQComponentState extends UIComponentState
{
    listOfFaqs: FaqDto[];
}

export class FAQComponent extends CRBTUIComponent<FAQComponentProps, UIComponentState>
{
    constructor(props: FAQComponentProps)
    {
        super(props);

        this.state = {listOfFaqs: []};
    }

    componentDidMount()
    {
        (this.getView() as FAQViewImpl).showLoader();
        (this.getAPIModel() as FAQAPIModel).getFAQ();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FAQViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FAQCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FAQAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as FAQViewImpl).dismissLoader();
        this.setState({listOfFaqs: data as FaqDto[]});
        
        window.scroll(0, 0);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void
    {
        (this.getView() as FAQViewImpl).dismissLoader();
        if(feature === APIFeatures.FAQ)
        {
            (this.getView() as FAQViewImpl).showPopup(description,AlertType.ERROR, this.getContext().getResources().getString(Strings.ok));
        }

        window.scroll(0, 0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/faq/faqcomponent.tsx